import React from 'react';
import StatCard from './widgets/StatCard';
import SimpleTable from './widgets/SimpleTable';
import PlaceholderChart from './widgets/PlaceholderChart';
import ChartRenderer from './ChartRenderer';
import StatsRenderer from './StatsRenderer';
import GroupRenderer from './widgets/GroupRenderer';
import StackRenderer from './widgets/StackRenderer';
import { listChartTypes, listStatTypes } from './widgets/registry';

const TextCard = ({ title, content }) => {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div>{content}</div>
        </div>
    );
};

// Placeholder for future types (chart, table, etc.)
const UnknownCard = ({ title }) => {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div>Unsupported section type</div>
        </div>
    );
};

export default function SectionRenderer({ section }) {
    const { type, title, content, component, props } = section;

    // Registry-driven detection first (allows custom types without suffix hacks)
    const chartTypes = listChartTypes();
    const statTypes = listStatTypes();

    // Built-in types
    if (type === 'text') {
        return <TextCard title={title} content={content} />
    }


    // Render Tables
    if (type === 'table') {
        const tableProps = props || section;
        return <SimpleTable title={tableProps.title ?? title} columns={tableProps.columns} rows={tableProps.rows} />
    }

    // Render Charts
    if (chartTypes.includes(type) || type.endsWith("chart")) {
        return <ChartRenderer section={section} />
    }

    // Render API-driven Stats
    if (statTypes.includes(type) || type.endsWith("stat-card")) {
        return <StatsRenderer section={section} />
    }

    // Render Groups (horizontal/vertical/grid layout)
    if (type === 'group') {
        return <GroupRenderer section={section} />
    }

    // Render Stacks (vertical stacking)
    if (type === 'stack') {
        return <StackRenderer section={section} />
    }

    // Custom component registry (by name)
    const registry = {
        StatCard,
        SimpleTable,
        PlaceholderChart,
    };

    // Render Custom Components
    if (type === 'component' && component && registry[component]) {
        const Comp = registry[component];
        return <Comp {...(props || {})} />
    }

    return <UnknownCard title={title} />
}


